import { useEffect, useState } from 'react';
import axios from 'axios';
import { getApiUrl } from '../../utils/api';

/* GET /nav/modules partagé (barre du bas · Plus · en-tête) : badges « À décider · n » par module + compteur crédits 62 / 100. Un seul appel pour toute la page. */
let cache = null; let pending = null; const subs = new Set();
const load = () => {
  if (pending) return pending;
  pending = axios.get(`${getApiUrl()}/nav/modules`, { withCredentials: true }).then((r) => { cache = r.data; subs.forEach((f) => f(cache)); return cache; }).catch(() => cache).finally(() => { pending = null; });
  return pending;
};
if (typeof window !== 'undefined') { window.addEventListener('credits-changed', load); window.addEventListener('accueil.updated', load); }

export const useNavModules = () => {
  const [d, setD] = useState(cache);
  useEffect(() => { subs.add(setD); const t0 = cache ? null : setTimeout(load, 1200); const id = setInterval(load, 120000); return () => { subs.delete(setD); clearInterval(id); if (t0) clearTimeout(t0); }; }, []);
  return d;
};
